import { MutationOptions, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import AchievementRepository from '@/repositories/AchievementRepository';
import { AchievementOverviewParams, PersonAchievement } from '@/types/achievement';

import useAPI from './useAPI';

export const useAchievementOverview = (params: AchievementOverviewParams, personId: string) => {
  const repository = AchievementRepository();

  return useAPI({
    queryKey: ['getAchievementsOverview', params, personId],
    queryFn: async () => {
      return await repository.getOverview(params, personId);
    }
  });
};

export const useCreatePersonAchievement = (
  options?: MutationOptions<PersonAchievement, AxiosError, PersonAchievement>
) => {
  const repository = AchievementRepository();

  return useMutation({
    mutationFn: (data: PersonAchievement) => repository.createPersonAchievement(data),
    ...options
  });
};
